import MultiLanguage from '../MultiLanguage';

export class ReplacementListState {
    private _id: string;
    private _name: MultiLanguage;
    private _value: number;
    private _isCandidateVisibleInReport: boolean;
    private _receiveJobOffers: boolean;
    private _receiveJobOffersAccordingToContract: boolean;
    private _shownAsWorking: boolean;
    private _requiresReason: boolean;
    private _requiresDocument: boolean;
    private _isEditable: boolean;
    private _isVisible: boolean;

    public constructor(data: any) {
        this._id = data.id;
        this._name = data.name ? new MultiLanguage(data.name) : new MultiLanguage({});
        this._value = data.value;
        this._isCandidateVisibleInReport = data.isCandidateVisibleInReport ? data.isCandidateVisibleInReport : false;
        this._receiveJobOffers = data.receiveJobOffers ? data.receiveJobOffers : false;
        this._receiveJobOffersAccordingToContract = data.receiveJobOffersAccordingToContract ? data.receiveJobOffersAccordingToContract : false;
        this._shownAsWorking = data.shownAsWorking ? data.shownAsWorking : false;
        this._requiresReason = data.requiresReason ? data.requiresReason : false;
        this._requiresDocument = data.requiresDocument ? data.requiresDocument : false;
        this._isEditable = data.isEditable;
        this._isVisible = data.isVisible;
    }

    public get id() {
        return this._id;
    }

    public get isEditable() {
        return this._isEditable;
    }

    public get isVisible() {
        return this._isVisible;
    }

    public set isVisible(isVisible: boolean) {
        this._isVisible = isVisible;
    }

    public get name() {
        return this._name;
    }

    public set name(name: MultiLanguage) {
        this._name = name;
    }

    public get value() {
        return this._value;
    }

    public set value(value: number) {
        this._value = value;
    }

    public get isCandidateVisibleInReport() {
        return this._isCandidateVisibleInReport;
    }

    public set isCandidateVisibleInReport(isCandidateVisibleInReport: boolean) {
        this._isCandidateVisibleInReport = isCandidateVisibleInReport;
    }

    public get receiveJobOffers() {
        return this._receiveJobOffers;
    }

    public set receiveJobOffers(receiveJobOffers: boolean) {
        this._receiveJobOffers = receiveJobOffers;
    }

    public get receiveJobOffersAccordingToContract() {
        return this._receiveJobOffersAccordingToContract;
    }

    public set receiveJobOffersAccordingToContract(receiveJobOffersAccordingToContract: boolean) {
        this._receiveJobOffersAccordingToContract = receiveJobOffersAccordingToContract;
    }

    public get shownAsWorking() {
        return this._shownAsWorking;
    }

    public set shownAsWorking(shownAsWorking: boolean) {
        this._shownAsWorking = shownAsWorking;
    }

    public get requiresReason() {
        return this._requiresReason;
    }

    public set requiresReason(requiresReason: boolean) {
        this._requiresReason = requiresReason;
    }

    public get requiresDocument() {
        return this._requiresDocument;
    }

    public set requiresDocument(requiresDocument: boolean) {
        this._requiresDocument = requiresDocument;
    }

    public getBehaviours() {
        return {
            isCandidateVisibleInReport: this._isCandidateVisibleInReport,
            receiveJobOffers: this._receiveJobOffers,
            receiveJobOffersAccordingToContract: this._receiveJobOffersAccordingToContract,
            shownAsWorking: this._shownAsWorking,
            requiresReason: this._requiresReason,
            requiresDocument: this._requiresDocument
        };
    }

    public setBehaviours(data: any) {
        this._isCandidateVisibleInReport = data.isCandidateVisibleInReport;
        this._receiveJobOffers = data.receiveJobOffers;
        this._receiveJobOffersAccordingToContract = data.receiveJobOffersAccordingToContract;
        this._shownAsWorking = data.shownAsWorking;
        this._requiresReason = data.requiresReason;
        this._requiresDocument = data.requiresDocument;
    }

    public validation(availableLanguages: string[]) {
        return this.name.allHasValue(availableLanguages)
        && this.value >= 0;
    }

    public infoToServer() {
        return {
            name: this._name,
            value: this._value,
            isCandidateVisibleInReport: this._isCandidateVisibleInReport,
            receiveJobOffers: this._receiveJobOffers,
            receiveJobOffersAccordingToContract: this._receiveJobOffersAccordingToContract,
            shownAsWorking: this._shownAsWorking,
            requiresReason: this._requiresReason,
            requiresDocument: this._requiresDocument,
            isVisible: this._isVisible
        };
    }
}
